import { createGlobalStyle } from 'styled-components';
import { resetCss } from './resetCss';
import { BREAKPOINTS, FONT_FAMILY, FONT_SIZE, FONT_WEIGHT, media } from './themes/constants';
import {
  antOverrideCssVariables,
  commonThemeVariables,
  darkThemeVariables,
  lightThemeVariables,
} from './themes/themeVariables';

import dealRoomBG from '../assets/images/deal-room-bg.jpg';

export default createGlobalStyle`

  ${resetCss}

  html {
    scroll-behavior: smooth;
  }


  [data-theme='light'],
  :root {
    ${lightThemeVariables}
  }

  [data-theme='dark'] {
    ${darkThemeVariables}
  }

  :root {
    ${commonThemeVariables};
    ${antOverrideCssVariables};
  } 

  [data-no-transition] * {
    transition: none !important;
  }

  body, .ant-typography, .ant-btn, .ant-input {
    font-family: ${FONT_FAMILY.main};
  }
  
  .range-picker {
    & .ant-picker-panels {
      @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px) {
        display: flex;
      flex-direction: column;
      }
    }
  }

  .search-overlay {
    box-shadow: var(--box-shadow);

    @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px)  {
      width: calc(100vw - 16px);
      max-width: 600px;
    }

    @media only screen and ${media.md} {
      width: 323px;
    }
  }

  a {
    color: var(--primary-color);
    &:hover,:active {
      color: var(--ant-primary-color-hover);
    }
  }
  
  .ant-picker-cell {
    color: var(--text-main-color);
  }

  .ant-picker-cell-in-view .ant-picker-calendar-date-value {
    color: var(--text-main-color);
    font-weight: ${FONT_WEIGHT.bold};
  }

  .ant-picker svg {
    color: var(--text-light-color);
  }

  // notifications start
  .ant-notification-notice {
    width: 36rem;
    padding: 2rem;
    min-height: 6rem;
    
    .ant-notification-notice-with-icon .ant-notification-notice-message {
      margin-bottom: 0;
      margin-right: 4rem;
    }

    .ant-notification-notice-with-icon .ant-notification-notice-description {
      margin-left: 4.375rem;
      margin-top: 0;
    }

    .ant-notification-notice-icon {
      font-size: 2.8125rem;
      margin-left: 0
    }

    .ant-notification-notice-close {
      top: 1.25rem;
      inset-inline-end: 1.25rem;
    }

    .ant-notification-notice-close-x {
      display: flex;
      font-size: 0.9375rem;
    }

    .notification-without-description {
      .ant-notification-notice-close {
        top: 1.875rem;
      }
      .ant-notification-notice-with-icon .ant-notification-notice-description  {
        margin-top: 0.625rem;
      }
    }
    
    .title {
      font-size: ${FONT_SIZE.xxl};
      height: 3rem;
      margin-left: 1.5rem;
      display: flex;
      align-items: center;
      font-weight: ${FONT_WEIGHT.bold};

      &.title-only {
        color: var(--text-main-color);
        font-size: ${FONT_SIZE.md};
        height: 2rem;
        line-height: 2rem;
        margin-left: 0.75rem;
        font-weight: ${FONT_WEIGHT.semibold};
      }
  }
  
    .description {
      color: #404040;
      font-size: ${FONT_SIZE.md};
      font-weight: ${FONT_WEIGHT.semibold};
      line-height: 1.375rem;
    }
  
    &.ant-notification-notice-success {
      border: 1px solid var(--success-color);
      background: var(--notification-success-color);
      
      .title {
        color: var(--success-color);
      }
    }
  
    &.ant-notification-notice-info {
      border: 1px solid var(--primary-color);
      background: var(--notification-primary-color);
  
      .title {
        color: var(--primary-color);
      }
    }
  
    &.ant-notification-notice-warning {
      border: 1px solid var(--warning-color);
      background: var(--notification-warning-color);
  
      .title {
        color: var(--warning-color);
      }
    }
  
    &.ant-notification-notice-error {
      border: 1px solid var(--error-color);
      background: var(--notification-error-color);
  
      .title {
        color: var(--error-color);
      }
    }
  
    .success-icon {
      color: var(--success-color);
    }
  
    .info-icon {
      color: var(--primary-color);
    }
  
    .warning-icon {
      color: var(--warning-color);
    }
  
    .error-icon {
      color: var(--error-color);
    }
  }
  
  .ant-menu-inline, .ant-menu-vertical {
    border-right: 0;
  }
  .ant-menu-submenu-popup > .ant-menu-vertical .ant-menu-title-content .ant-btn span {
    color: var(--text-main-color);
  }

  @media only screen and ${media.xs} and (max-width: ${BREAKPOINTS.md - 0.02}px) {
    .ant-notification-notice {
      width: calc(100vw - 32px);
      max-width: 600px;
      padding: 1rem;
      min-height: 4rem;

      .ant-notification-notice-with-icon .ant-notification-notice-message {
        margin-left: 1.5rem;
        font-size: ${FONT_SIZE.lg};
      }

      .ant-notification-notice-with-icon .ant-notification-notice-description {
        margin-left: 2.5rem;
        font-size: ${FONT_SIZE.md};
      }

      .ant-notification-notice-icon {
        font-size: 1.875rem;
      }

      .ant-notification-notice-close {
        top: 0.75rem;
        inset-inline-end: 0.75rem;
      }

      .title {
        font-size: ${FONT_SIZE.lg};
        height: 2.5rem;

        &.title-only {
          font-size: ${FONT_SIZE.md};
          height: 1.5rem;
          line-height: 1.5rem;
          margin-left: 0.5rem;
        }
      }

      .description {
        font-size: ${FONT_SIZE.md};
        line-height: 1.125rem;
      }
    }
  }
  // notifications end

  .rtl {
    .rtl-reverse {
      flex-direction: row-reverse;
    }

    .ant-form-item-label>label {
      flex-direction: row-reverse;
    }

    .ant-form-rtl .ant-form-item-label>label.ant-form-item-required::before {
      margin-right: 4px;
      margin-left: 0px;
    }

    .ant-steps-rtl {
      direction: initial
    }

    .ant-steps-rtl .ant-steps-item-tail {
      right: auto;
      left: 0;
    }
  }
  .ant-popover-rtl .popupCountryListRtl{
    display: flex;
    flex-direction: row-reverse;
    justify-content:flex-end;
    position: relative;
  }
  .ant-popover-rtl .popupCountryListRtl span:nth-child(2) > div{ 
    display: flex;
    flex-direction: row-reverse;
  }
  .ant-popover-rtl .popupCountryListRtl span:nth-child(2) > div > div:nth-child(1){
    padding-right:14px
  }
  .ant-popover-rtl .popupCountryListRtl span:nth-child(2) > div > div:nth-child(2){
    position:absolute;
    right:0;
  }

  .ant-form-rtl {
    .anticon-left {
      transform: scaleX(-1);
      margin-left: 0.75rem;
    }
    
    .rtl-reverse {
      flex-direction: row-reverse;
    }
  }

  .ant-modal-wrap:has(> .dealRoomInviteModal){
     background: url(${dealRoomBG}) no-repeat center center fixed;
  }

  .ant-row-rtl .ant-steps-item-container {
    direction: rtl;
  }

  .ql-container {
    min-height: 200px;
  }

  .ql-editor {
    min-height: inherit; /* Inherits min-height from .ql-container */
  }

  .always-clear .ant-select-clear {
    opacity: 1 !important;
    visibility: visible !important;
  }

  .ant-upload-list-item-info a, .ant-upload-list-item-name {
    cursor: pointer;
  }

  .ant-tooltip {
    max-width:100%;
    min-width:100px;

    .ant-tooltip-inner {
      min-width:80px;
    }
  }

  .ant-notification-notice {
    direction: rtl;
    text-align: right;
  }

  .ant-badge-dot {
    background: #ce6239;
    box-shadow: 0 0 0 1px #ce6239;
  }
`;
